import { observer } from 'mobx-react-lite';
import { useTranslation } from 'next-i18next';
import styles from '@features/productPreview/sections/StickyBar/components/StickyLinkButton/StickyLinkButton.styles';
import { productPageState } from '@features/productPreview/mobX/state/context';
import { STICKYBAR_MAP, VisibleSectionType } from '@features/productPreview/const';
type PropTypes = {
  type: VisibleSectionType;
};
const StickyLinkButton = ({
  type
}: PropTypes) => {
  const {
    t
  } = useTranslation('common');
  const state = productPageState;
  const active = state.actualVisibleSection === type;
  const stickyBarMapValue = STICKYBAR_MAP.get(type);
  if (stickyBarMapValue === undefined) {
    return null;
  }
  const href = stickyBarMapValue.href || '';
  const text = t(stickyBarMapValue.text);
  const offsetY = stickyBarMapValue.offsetY || 100;
  const element = document.querySelector(href);
  const handleLinkButtonClick = () => {
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element?.getBoundingClientRect().top;
    if (elementRect) {
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offsetY;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    state.setActualVisibleSection(type);
    if (type === VisibleSectionType.PRODUCT_DELIVERY_ASSEMBLY) {
      state.setDeliveryOpen(true);
    }
  };
  return element && <button type="button" sx={styles.linkButton(active)} onClick={() => handleLinkButtonClick()}>
        {text}
      </button>;
};
export default observer(StickyLinkButton);